module.exports = __webpack_public_path__ + "static/media/Mentor2021.e27b2bef.jpeg";